import React, { Fragment, Component } from "react";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/core/styles";
import UploadFileDialog from "../files/addFileModal";

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  }
});

class AddFileButton extends Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };

  handleClose = value => {
    this.setState({ selectedValue: value, open: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Fab
          className={classes.fab}
          onClick={this.handleClickOpen}
          color="primary"
        >
          <AddIcon />
        </Fab>
        <UploadFileDialog
          onSubmit={(...data) => {
            console.log({ data });
          }}
          onClose={this.handleClose}
          opened={this.state.open}
        />
      </Fragment>
    );
  }
}

export default withStyles(styles)(AddFileButton);



// WEBPACK FOOTER //
// ./src/components/stats/load-file-button.js